export default "__VITE_ASSET__eaafacb4__"